export default __webpack_public_path__ + "static/media/pursuit-menu-myresults-off.e808ba8f.svg";